//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "turn-wrap"
  }, [_vm._l(_vm.giftList.slice(0, 8), function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "turn-item",
      class: [+index === _vm.focusIndex && 'focus']
    }, [_c('img', {
      staticClass: "turn-item-img",
      attrs: {
        "src": item.imageUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.name))])]);
  }), _vm._v(" "), _c('div', {
    ref: "pointer",
    staticClass: "pointer",
    style: _vm.pointerStyles
  })], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-b9540648',
  render,
  name: 'CbTurntable',
  props,
  data() {
    return {
      pointerStyles: {},
      deg: 0
    };
  },
  computed: {
    /**
     * 根据旋转角度计算该高亮的
     */
    focusIndex() {
      var everyDeg = 45;
      var num = Math.floor(this.deg / everyDeg);
      if (+this.deg === 0) {
        return -1;
      }
      return num;
    }
  },
  methods: {
    /**
     * 转盘转动
     * @param {number} giftIndex
     */
    runAnimation(giftIndex) {
      this.pointerStyles = {
        transition: 'all 2s ease-in-out 0s',
        background: '#999'
      };
      var timer = setInterval(() => {
        this.deg = this.getRotationDegrees(this.$refs.pointer);
      }, 16);
      var turn = giftIndex / 8 + 1 / 16;
      while (turn < 5) {
        turn += 1;
      }
      this.pointerStyles = {
        transition: 'all 2s',
        transform: "rotate(" + turn * 360 + "deg)"
      };
      setTimeout(() => {
        this.$emit('runEnd');
      }, 2000);
      setTimeout(() => {
        clearInterval(timer);
        this.deg = 0;
        this.pointerStyles = {
          transition: 'all 0s',
          transform: 'rotate(0deg)'
        };
      }, 2500);
    },
    /**
     * 获取指针的转动角度
     * @param {*} element //指针ref
     */
    getRotationDegrees(element) {
      var style = window.getComputedStyle(element);
      var transformString = style['-webkit-transform'] || style['-moz-transform'] || style.transform;
      if (!transformString || transformString === 'none') {
        return 0;
      }
      var splits = transformString.split(',');
      var parenLoc = splits[0].indexOf('(');
      var a = parseFloat(splits[0].substr(parenLoc + 1));
      var b = parseFloat(splits[1]);
      var rad = Math.atan2(b, a);
      var deg = 180 * rad / Math.PI;
      if (deg < 0) {
        deg += 360;
      }
      return deg;
    }
  }
});